import React, {useEffect, useState} from "react";
import API from 'libs/api';
import { useNavigate } from 'react-router-dom';
import ICON from 'components/cmp_icon/cmp_icon'
import TABLE from 'components/cmp_table/cmp_table'

import './crd_providers.css'



export default function CRD_PROVIDERS({ var_status }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const navigate = useNavigate();

    //  data table variables
    const [ var_data, set_data ] = useState([]);
    const [ var_data_settings, set_data_settings ] = useState({
        limit: 15,
        offset: 0,
        totalrows: 0,
        search: '',
        sortby: 'lastmodified',
        sortorder: 'asc'
    });
    const [ var_totalrows, set_totalrows ] = useState(0);

    //  data ready variables
    const [ var_ready, set_ready ] = useState(false);
    const [ var_processing, set_processing ] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        get_providers(var_data_settings);
    }, [])



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_providers(data_settings) {

        set_ready(false);
        set_processing('processing');

        //  use current data settings if none are submitted
        data_settings && set_data_settings(data_settings);
        let settings = data_settings || var_data_settings;

        try {
            let results = await API_get_providers(settings);

            //  set totalrows
            set_totalrows(results.totalrows);

            //  set data
            set_data(results.results === undefined ? [] : results.results);

            set_processing('inactive');
            set_ready(true);
        } catch (e) {
            set_processing('error');
        }

    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_providers(settings){
        let var_parameters = {queryStringParameters: settings};
        return API.get('admin-providers', '/get-providers/' + var_status, var_parameters);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_provider(item){
        navigate('/provider/'+item.id);
    }

    function onChange_status(status){
        let new_filter = {...var_data_settings};
        new_filter.status = status
        set_data_settings(new_filter)
        get_providers(new_filter);
    }


    // RENDER CONTAINER ================================================================================================

    return (

        <div className='card providers'>
            <div className='card__header'>
                <div className='card__header__title_totalrows'>
                    <div className='text--md bold'>Providers</div>
                    <div className='card__header__totalrows text--md normal'>{var_totalrows.toLocaleString()}</div>
                </div>
            </div>
            <div className='card__content'>

                <TABLE
                    var_data_settings={var_data_settings}
                    set_data_settings={set_data_settings}
                    onChange={get_providers}
                    processing={var_processing}
                    totalrows={var_totalrows}
                >
                    <headers>
                        <header sortby='reviewed' width='48px'>Rev</header>
                        <header sortby='name'>Provider name</header>
                        <header sortby='locations' width='112px'>Locations</header>
                        <header sortby='activities' width='112px'>Activities</header>
                        <header sortby='activities_categories' width='112px'>Categories</header>
                        <header sortby='ages' width='64px'>Ages</header>
                        <header sortby='lastmodified' width='192px'>Modified</header>
                        <header sortby='lastmodifiedby'>Modified by</header>
                    </headers>
                    <data>
                        {var_data.map(item =>
                            <row key={item.id} onClick={()=>onClick_provider(item)}>
                                <cell>
                                    {item.reviewed === 'YES' &&
                                        <div className='cell--icon green'>
                                            <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                        </div>
                                    }
                                </cell>
                                <cell>{item.name}</cell>
                                <cell>
                                    <div className='cell--icon__left'>
                                        {item.locations > 0 && item.locations === item.locations_reviewed ?
                                            <div className='cell--icon green'>
                                                <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                            </div>
                                            : item.locations > 0 && item.locations !== item.locations_reviewed ?
                                                <div className='cell--icon orange'>
                                                    <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                                </div>
                                                : item.locations === 0  ?
                                                    <div className='cell--icon red'>
                                                        <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                                    </div>
                                                    : ''
                                        }
                                        {item.locations}
                                    </div>
                                </cell>
                                <cell>
                                    <div className='cell--icon__left'>
                                    {item.activities > 0 && item.activities === item.activities_reviewed ?
                                        <div className='cell--icon green'>
                                            <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                        </div>
                                        : item.activities > 0 && item.activities !== item.activities_reviewed ?
                                            <div className='cell--icon orange'>
                                                <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                            </div>
                                            : item.activities === 0  ?
                                                <div className='cell--icon red'>
                                                    <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                                </div>
                                                : ''
                                    }
                                    {item.activities}
                                    </div>
                                </cell>
                                <cell>{item.activities_categories}</cell>
                                <cell>
                                    {item.ages === 'YES' && item.ages_reviewed === 'YES' ?
                                        <div className='cell--icon green'>
                                            <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                        </div>
                                        : item.ages === 'YES' && item.ages_reviewed !== 'YES' ?
                                        <div className='cell--icon orange'>
                                            <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                        </div>
                                            :
                                            <div></div>
                                    }
                                </cell>
                                <cell>{item.lastmodified}</cell>
                                <cell>{item.lastmodifiedby}</cell>
                            </row>
                        )}
                    </data>
                </TABLE>

            </div>
        </div>

    )
}